import type { FC } from 'react';

import { useContent } from '@eneco/cms';
import { Video as VideoPlayer } from '@eneco/components/Video/Video';
import { Stack, Text } from '@eneco/sparky';

import type { VideoContent } from './video-content.types';

/**
 * `Video` block for the CMS-agnostic lane, serving **both** providers. A leaf: an embedded YouTube
 * player with an optional caption.
 *
 * Drops the legacy component's `fields.*.editable` checks — those render an empty embed so the
 * Sitecore Experience Editor has something to click, and this lane never runs inside it.
 */
const Video: FC = () => {
  const content = useContent<VideoContent>();

  if (!content.youtubeVideoId) return null;

  return (
    <Stack gap="6">
      <VideoPlayer title={content.youtubeVideoTitle} videoId={content.youtubeVideoId} />
      {content.captionText && (
        <Text size={{ md: 'BodyL' }} color="textLowEmphasis">
          {content.captionText}
        </Text>
      )}
    </Stack>
  );
};

export default Video;
